import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeating = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 5.12891C4.34518 5.12891 4.625 5.40873 4.625 5.75391V13.3789H3.375V5.75391C3.375 5.40873 3.65482 5.12891 4 5.12891ZM13 5.12891C13.3452 5.12891 13.625 5.40873 13.625 5.75391V13.3789H12.375V5.75391C12.375 5.40873 12.6548 5.12891 13 5.12891ZM7 5.12891C7.34518 5.12891 7.625 5.40873 7.625 5.75391V10.3037C7.62478 10.6487 7.34504 10.9287 7 10.9287C6.65496 10.9287 6.37522 10.6487 6.375 10.3037V5.75391C6.375 5.40873 6.65482 5.12891 7 5.12891ZM10 5.12891C10.3452 5.12891 10.625 5.40873 10.625 5.75391V10.3037C10.6248 10.6487 10.345 10.9287 10 10.9287C9.65496 10.9287 9.37522 10.6487 9.375 10.3037V5.75391C9.375 5.40873 9.65482 5.12891 10 5.12891Z",
		fill: "black"
	})
});
export default SvgHeating;
